import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import { BrowserRouter as Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import Routes from './routes'

ReactDOM.render(
  <Router>
    <Routes />
  </Router>,
  document.getElementById('root'),
)

serviceWorker.unregister()
